/**
 * Module Configuration
 * Defines all modules available in the admin panel for ACM
 * IMPORTANT: paths and routes must match actual routes in routes/index.js
 */

export const MODULES = {
  DASHBOARD: {
    id: 'DASHBOARD',
    name: 'Dashboard',
    icon: 'bx-home-circle',
    path: '/dashboard',
    routes: ['/dashboard'],
  },
  ROOM: {
    id: 'ROOM',
    name: 'Room Management',
    icon: 'bx-door-open',
    path: '/Room',
    routes: [
      '/Room',
      '/RoomType',
      '/RoomFeature',
      '/RoomHospitalityService',
      '/Booking',
      '/RoomCancel',
      '/AmenityType',
      '/Amenities',
    ],
  },
  FOOD: {
    id: 'FOOD',
    name: 'Food Management',
    icon: 'bx-food-menu',
    path: '/Food',
    routes: [
      '/Food',
      '/Foodcuisine',
      '/FoodAddOn',
      '/FoodSettings',
      '/FoodOrder',
    ],
  },
  TABLE: {
    id: 'TABLE',
    name: 'Table Management',
    icon: 'bx-table',
    path: '/Table',
    routes: [
      '/Table',
      '/TableBooking',
    ],
  },
  AMENITY: {
    id: 'AMENITY',
    name: 'Amenity Management',
    icon: 'bx-spa',
    path: '/AmenityType',
    routes: [
      '/AmenityType',
      '/Amenities',
    ],
  },
  ATTRACTION: {
    id: 'ATTRACTION',
    name: 'Attractions',
    icon: 'bx-map-pin',
    path: '/Attraction',
    routes: ['/Attraction'],
  },
  TAXI: {
    id: 'TAXI',
    name: 'Taxi Service',
    icon: 'bx-taxi',
    path: '/Taxi',
    routes: ['/Taxi'],
  },
  USERS: {
    id: 'USERS',
    name: 'User Management',
    icon: 'bx-user',
    path: '/User',
    routes: ['/User', '/DeliveryBoy'],
  },
  NOTIFICATION: {
    id: 'NOTIFICATION',
    name: 'Notifications',
    icon: 'bx-bell',
    path: '/Notification',
    routes: ['/Notification', '/ManageNotification'],
  },
  CHAT: {
    id: 'CHAT',
    name: 'Chat',
    icon: 'bx-chat',
    path: '/ChatList',
    routes: ['/ChatList'],
  },
  COUPON: {
    id: 'COUPON',
    name: 'Coupon Management',
    icon: 'bx-purchase-tag',
    path: '/coupon',
    routes: ['/coupon'],
  },
  BANNER: {
    id: 'BANNER',
    name: 'Banner Management',
    icon: 'bx-image',
    path: '/banner',
    routes: ['/banner'],
  },
  TRANSPORTATION: {
    id: 'TRANSPORTATION',
    name: 'Transportation',
    icon: 'bx-car',
    path: '/transport/requests',
    routes: ['/transport'],
  },
  ANALYTICS: {
    id: 'ANALYTICS',
    name: 'Analytics & Reports',
    icon: 'bx-bar-chart-alt-2',
    path: '/analytics',
    routes: ['/analytics', '/activity-logs'],
  },
  SETTINGS: {
    id: 'SETTINGS',
    name: 'Settings',
    icon: 'bx-cog',
    path: '/FoodSettings',
    routes: ['/FoodSettings'],
  },
  TEAM: {
    id: 'TEAM',
    name: 'Team Management',
    icon: 'bx-group',
    path: '/team',
    routes: ['/team'],
    superAdminOnly: true,
  },
};

/**
 * Get module by route path
 * @param {string} path - Current route path
 * @returns {object|null} Module object or null
 */
export const getModuleByRoute = (path) => {
  // Normalize path for comparison (case-insensitive for first character)
  const normalizedPath = path.toLowerCase();

  for (const moduleId in MODULES) {
    const module = MODULES[moduleId];
    if (module.routes.some((route) => normalizedPath.startsWith(route.toLowerCase()))) {
      return module;
    }
  }
  return null;
};

/**
 * Get all module IDs
 * @returns {string[]} Array of module IDs
 */
export const getAllModuleIds = () => {
  return Object.keys(MODULES);
};

/**
 * Get modules for permission checkboxes (excludes TEAM for non-super admins)
 * @param {boolean} includeSuperAdminOnly - Include super admin only modules
 * @returns {object[]} Array of module objects
 */
export const getModulesForPermissions = (includeSuperAdminOnly = false) => {
  return Object.values(MODULES).filter((module) => {
    if (module.superAdminOnly && !includeSuperAdminOnly) {
      return false;
    }
    return true;
  });
};

export default MODULES;
